import { Clinic, ProgramType, User } from '@enaratech/funnel-helper';

/**
 * A member's program type can be defined in two ways:
 *
 * 1. **Distance** — `clinicState.program` (`Clinic.program`), derived server-side
 *    from the closest clinic to the member's zip code. This is the origin/default
 *    for brand-new, anonymous leads who do not have a user record yet.
 * 2. **Override** — `user.programType` (core `program_type`), an explicit per-user
 *    value stored in core (eg. referral leads, ops adjustments).
 *
 * The override must always win when present; the clinic (distance) value is only
 * a fallback for flows where there is no user yet (anonymous funnel) or no stored
 * override. Reading `clinicState.program` directly at a call site silently drops
 * the override and defaults the member to `in_clinic` — this helper centralizes
 * the precedence so that cannot happen.
 *
 * A falsy `programType` (empty string / null / undefined) is treated as "no
 * override" and falls through to the clinic value.
 */
export const getEffectiveProgramType = ({
  user,
  clinic,
}: {
  user?: Pick<User, 'programType'> | null;
  clinic?: Pick<Clinic, 'program'> | null;
}): ProgramType | null => {
  return user?.programType || clinic?.program || null;
};
